export const DASHBOARD = '/';

export const LOGIN = '/login';
export const REGISTER = '/register';
export const RESET_PASSWORD = '/reset-password';
export const SET_PASSWORD = '/set-password';

export const USER = '/user';
export const EDIT_USER = '/edit-user/:id'
export const createUserEditRoute = id => `/edit-user/${id}`;
export const ORDER = '/order';
export const ORDERINFO = '/order-info/:id';
export const createOrderRoute = id => `/order-info/${id}`;

export const STORE = '/store/:id'
export const createStoreRoute = id => `/store/${id}`;

export const STORE_USER = '/store-user';
export const STORE_USER_ADD = '/store-user/add';
export const STORE_USER_EDIT = '/store-user/edit/:id';
export const addEditStoreUserRoute = id => `/store-user/edit/${id}`;

export const INVENTORY = '/inventory';
export const CATALOG = 'https://www.canva.com/design/DAF41qCIotk/POSHmZ5IqEzHN0yaeoAgPQ/view?utm_content=DAF41qCIotk&utm_campaign=designshare&utm_medium=link&utm_source=viewer';

export const ROLE = '/role';
export const MANAGE_PERMISSION = "/manage-permission/:id";
export const managePermission = (id) => `/manage-permission/${id}`;

export const CHANGE_PASSWORD = '/change-password';

export const EDIT_PROFILE = '/edit-profile';

export const HELP = '/help';
